// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalNavItem__item___YwJ5Q {
    --bg-color: var(--color-bg-stripe);
    --typo-color: var(--color-typo-primary);

    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 0.4rem 0.8rem;

    font-size: var(--size-text-xs);
    line-height: var(--line-height-text-m);

    background-color: var(--bg-color);
    border-radius: 0.4rem;

    & * {
        color: var(--typo-color);
    }

    &:hover {
        --bg-color: var(--color-control-bg-ghost);
    }

    &.ModalNavItem__active___X69_X {
        --bg-color: var(--color-control-bg-primary);
        --typo-color: var(--color-control-typo-primary);

        &:hover {
            --bg-color: var(--color-control-bg-primary-hover);
            --typo-color: var(--color-control-typo-primary-hover);
        }
    }

    &.ModalNavItem__disabled___zBYRs {
        --typo-color: var(--color-typo-ghost);

        cursor: default;

        &:hover {
            --bg-color: var(--color-bg-stripe);
        }
    }
}

.ModalNavItem__additionalText___QzE1s {
    width: 10rem;
    text-align: end;
}

.ModalNavItem__right___qB3V9 {
    display: flex;
    flex-direction: row;
    gap: 0.4rem;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalTemplate/ModalNav/ModalNavItem/ModalNavItem.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,uCAAuC;;IAEvC,eAAe;IACf,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;;IAEjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,sBAAsB;;IAEtB,8BAA8B;IAC9B,sCAAsC;;IAEtC,iCAAiC;IACjC,qBAAqB;;IAErB;QACI,wBAAwB;IAC5B;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,2CAA2C;QAC3C,+CAA+C;;QAE/C;YACI,iDAAiD;YACjD,qDAAqD;QACzD;IACJ;;IAEA;QACI,qCAAqC;;QAErC,eAAe;;QAEf;YACI,kCAAkC;QACtC;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".item {\n    --bg-color: var(--color-bg-stripe);\n    --typo-color: var(--color-typo-primary);\n\n    cursor: pointer;\n    user-select: none;\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    padding: 0.4rem 0.8rem;\n\n    font-size: var(--size-text-xs);\n    line-height: var(--line-height-text-m);\n\n    background-color: var(--bg-color);\n    border-radius: 0.4rem;\n\n    & * {\n        color: var(--typo-color);\n    }\n\n    &:hover {\n        --bg-color: var(--color-control-bg-ghost);\n    }\n\n    &.active {\n        --bg-color: var(--color-control-bg-primary);\n        --typo-color: var(--color-control-typo-primary);\n\n        &:hover {\n            --bg-color: var(--color-control-bg-primary-hover);\n            --typo-color: var(--color-control-typo-primary-hover);\n        }\n    }\n\n    &.disabled {\n        --typo-color: var(--color-typo-ghost);\n\n        cursor: default;\n\n        &:hover {\n            --bg-color: var(--color-bg-stripe);\n        }\n    }\n}\n\n.additionalText {\n    width: 10rem;\n    text-align: end;\n}\n\n.right {\n    display: flex;\n    flex-direction: row;\n    gap: 0.4rem;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `ModalNavItem__item___YwJ5Q`,
	"active": `ModalNavItem__active___X69_X`,
	"disabled": `ModalNavItem__disabled___zBYRs`,
	"additionalText": `ModalNavItem__additionalText___QzE1s`,
	"right": `ModalNavItem__right___qB3V9`
};
export default ___CSS_LOADER_EXPORT___;
